import React from "react";
import { Link } from "react-router-dom";
import { FileText, Mic, ArrowRight } from "lucide-react";

/** Cross-promo suggestion shown on every individual course detail page. */
export function CareerToolsCTA() {
  return (
    <div className="mt-14" data-testid="course-detail-career-tools-section">
      <h2 className="text-xl sm:text-2xl font-medium text-[#f7f8f8] mb-1">Level Up Beyond Courses</h2>
      <p className="text-sm text-slate-400 mb-5">Free AI-powered tools to land your next role — no course purchase needed.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Link to="/resume-builder" data-testid="course-detail-resume-builder-card"
          className="group relative overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-br from-blue-500/10 to-transparent p-6 hover:border-blue-400/30 hover:-translate-y-1 transition-all">
          <div className="w-11 h-11 rounded-xl bg-blue-400/15 flex items-center justify-center mb-4">
            <FileText className="w-5 h-5 text-blue-300" />
          </div>
          <h3 className="font-heading text-lg font-semibold text-white">AI Resume Builder</h3>
          <p className="text-sm text-slate-400 mt-1.5">Build an ATS-ready resume in minutes with AI-written bullet points, tailored to any role.</p>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-blue-300 group-hover:text-blue-200 mt-4">
            Build my resume <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </Link>
        <Link to="/interview" data-testid="course-detail-interview-prep-card"
          className="group relative overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-br from-violet-500/10 to-transparent p-6 hover:border-violet-400/30 hover:-translate-y-1 transition-all">
          <div className="w-11 h-11 rounded-xl bg-violet-400/15 flex items-center justify-center mb-4">
            <Mic className="w-5 h-5 text-violet-300" />
          </div>
          <h3 className="font-heading text-lg font-semibold text-white">AI Interview Prep</h3>
          <p className="text-sm text-slate-400 mt-1.5">Practice with real AI voice interviews and get instant feedback on confidence, eye contact & answers.</p>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-violet-300 group-hover:text-violet-200 mt-4">
            Start practicing <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </Link>
      </div>
    </div>
  );
}
